module.exports = __webpack_public_path__ + "img/government.bb817a58.png";